import { render, staticRenderFns } from "./SubscriptionsTable.vue?vue&type=template&id=395b6e91&scoped=true&"
import script from "./SubscriptionsTable.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsTable.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsTable.vue?vue&type=style&index=0&id=395b6e91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b6e91",
  null
  
)

export default component.exports